import { MarketplaceRouterProvider, useRouter } from './router/MarketplaceRouter';
import { MarketplaceNav } from './shell/MarketplaceNav';
import { MarketplaceFooter } from './shell/MarketplaceFooter';

import { HomeScreen } from './screens/HomeScreen';
import { BrowseScreen } from './screens/BrowseScreen';
import { CategoryScreen } from './screens/CategoryScreen';
import { ServicesListScreen } from './screens/ServicesListScreen';
import { ServiceDetailScreen } from './screens/ServiceDetailScreen';
import { VendorProfileScreen } from './screens/VendorProfileScreen';
import { SignInScreen, SignUpScreen } from './screens/AuthScreens';
import {
  RequestCreateScreen,
  OffersScreen,
  MessagesScreen,
} from './screens/RequestFlowScreens';
import { DashboardScreen } from './screens/DashboardScreens';

function ActiveScreen() {
  const { route } = useRouter();
  switch (route.name) {
    case 'home':
      return <HomeScreen />;
    case 'browse':
      return <BrowseScreen />;
    case 'category':
      return <CategoryScreen />;
    case 'services':
      return <ServicesListScreen />;
    case 'service':
      return <ServiceDetailScreen />;
    case 'vendor':
      return <VendorProfileScreen />;
    case 'signin':
      return <SignInScreen />;
    case 'signup':
      return <SignUpScreen />;
    case 'request':
      return <RequestCreateScreen />;
    case 'offers':
      return <OffersScreen />;
    case 'messages':
      return <MessagesScreen />;
    case 'dashboard':
      return <DashboardScreen />;
    default:
      return <HomeScreen />;
  }
}

export function MarketplaceApp() {
  return (
    <MarketplaceRouterProvider>
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          background: 'var(--color-background-primary)',
          color: 'var(--color-text-primary)',
          fontFamily: 'var(--font-family-body)',
        }}
      >
        <MarketplaceNav />
        <main style={{ flex: 1 }}>
          <ActiveScreen />
        </main>
        <MarketplaceFooter />
      </div>
    </MarketplaceRouterProvider>
  );
}
